import { TextInput } from 'react-native';

export default function BottomSheetTextInput(props) {
  return <TextInput {...props} />;
}
